
{
  "familyId": "SPR-LEEN-C-S-K",
  "questions": [
    {
      "id": "SPR-LEEN-C-S-K-001",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "In welk woord klinkt de C als een S?",
      "context": null,
      "options": ["circus", "cola", "computer", "cake"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "C als S of K", "content": "De letter C klinkt als S voor e en i: circus, cent, citroen. De C klinkt als K voor a, o en u: cola, computer, cake.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "c_pronunciation_s",
      "variantIndex": 1,
      "feedback": { "explanationText": "De C klinkt als S voor de letters e en i. In 'circus' staat de C voor een i, dus klinkt het als S. Bij cola, computer en cake staat de C voor a, o of u, dus klinkt het als K.", "distractorExplanations": { "0": "Correct! C + i = S-klank: circus.", "1": "Fout: C + o = K-klank. In circus klinkt de C als S (C + i).", "2": "Fout: C + o = K-klank. In circus klinkt de C als S (C + i).", "3": "Fout: C + a = K-klank. In circus klinkt de C als S (C + i)." } }
    },
    {
      "id": "SPR-LEEN-C-S-K-002",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Welk woord begint met een K-klank?",
      "context": null,
      "options": ["cactus", "centrum", "citroen", "circus"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "C als K-klank", "content": "De C klinkt als K voor a, o en u: cactus, cola, computer. Voor e en i klinkt de C als S: centrum, circus.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "c_pronunciation_k",
      "variantIndex": 2,
      "feedback": { "explanationText": "De C klinkt als K voor de letters a, o en u. In 'cactus' staat de C voor een a, dus klinkt het als K. Bij centrum, citroen en circus staat de C voor e of i, dus klinkt het als S.", "distractorExplanations": { "0": "Correct! C + a = K-klank: cactus.", "1": "Fout: C + e = S-klank. In cactus klinkt de C als K (C + a).", "2": "Fout: C + i = S-klank. In cactus klinkt de C als K (C + a).", "3": "Fout: C + i = S-klank. In cactus klinkt de C als K (C + a)." } }
    }
  ]
}
